import './index.scss'

import { useEffect, useState } from 'react'

interface LoadingIndicatorProps {
  fullScreen?: boolean
  // Waits this long before showing, so a load that finishes quickly doesn't
  // flash a spinner on its way past. Off unless asked for.
  delayMs?: number
}

export default function LoadingIndicator(props: LoadingIndicatorProps = {
  fullScreen: true
}) {
  const delayMs = props.delayMs ?? 0;
  const [isVisible, setIsVisible] = useState(delayMs === 0);

  useEffect(() => {
    if (delayMs === 0) return;

    const timeout = window.setTimeout(() => setIsVisible(true), delayMs);

    return () => window.clearTimeout(timeout);
  }, [delayMs]);

  return <div className={(props.fullScreen === undefined || props.fullScreen === true) ? "loading-indicator full-screen" : 'loading-indicator'}>
    {isVisible ? <div className='loading-spinner' /> : null}
  </div>
}
